import types from './constants'

export default {
  [types.BENCHMARK_SORT]: (sort) => ({
   type: types.BENCHMARK_SORT,
   sort
  }),
  [types.BENCHMARK_PENDING]: () => ({
   type: types.BENCHMARK_PENDING,
  }),
  [types.BENCHMARK_COMPLETE]: (report, activities) => ({
   type: types.BENCHMARK_COMPLETE,
   report,
   activities,
  }),
  [types.BENCHMARK_ERROR]: (error) => ({
   type: types.BENCHMARK_ERROR,
   error
  }),
  [types.BENCHMARK_CACHE_SAVE]: (payload) => ({
    type: types.BENCHMARK_CACHE_SAVE,
    payload
   }),
}